<template>
  <div style="height: 100%;">
    <chart 
    :phpURL="phpURL"
    :sendValue="getData"
    >
      <bar :style="barStyle" :chart-data="datacollection" :options="chartOptions"/>
    </chart>
  </div>
</template>

<script>
import Bar from '../Chartjs/BarChart'
import GlobalChart from '../Misc/GlobalChart'

const tradName = 'timePerScene'
const phpName = 'TimePerScene'
const color = '#f87979'

export default {
  props: {
    barStyle: {
      type: String,
      required: false,
      default: 'height: calc(100% - 42px);'
    }
  },
  data: function () {
    return {
      chartOptions: { // The chartJS options
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          reverse: false
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: this.$vuetify.t('$vuetify.charts.' + tradName + '.yaxis')
            }
          }],
          xAxes: [{
            ticks: {
              display: false
            },
            scaleLabel: {
              display: true,
              labelString: this.$vuetify.t('$vuetify.charts.' + tradName + '.xaxis')
            }
          }]
        },
        tooltips: {
          callbacks: {
            title: function (title) {
              return title[0].xLabel[0].toUpperCase() + title[0].xLabel.substring(1).split('_').join(' ')
            },
            label: function (tooltipItem) {
              var totalSeconds = tooltipItem.yLabel
              var hours = Math.floor(totalSeconds / 3600)
              totalSeconds %= 3600
              var minutes = Math.floor(totalSeconds / 60)
              var seconds = totalSeconds % 60
              return (hours > 0 ? hours + 'h ' : '') + (minutes > 0 ? minutes + 'mn ' : '') + seconds + 's'
            }
          },
          type: 'index',
          axis: 'x',
          intersect: false
        }
      },
      datacollection: {} // The data sent to the chart
    }
  },
  mounted () {},
  components: {
    'bar': Bar,
    'chart': GlobalChart
  },
  computed: {
    phpURL () {
      return 'http://adammeraihi.000webhostapp.com/charts/modeles/' + phpName + '.php'
    }
  },
  methods: {
    getData (response) {
      var labels = Object.keys(response.data.result)
      var data = Object.values(response.data.result)

      // Send the new data
      this.datacollection = {
        labels: labels,
        datasets: [
          {
            label: this.$vuetify.t('$vuetify.charts.' + tradName + '.legend'),
            backgroundColor: color,
            data: data
          }
        ]
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/NewCharts/TimePerScene.vue